import { Neo } from "@singularsystems/neo-react";
import ManagerCheckQueryComponentVM from "./ManageCheckQueryComponentVM";
import { observer } from "mobx-react";
import React from "react";
import { TextConstants } from "../../../Common/TextConstants";
import { Validation } from "@singularsystems/neo-core";

interface IManagedCheckQueryComponentProps {
    viewModel: ManagerCheckQueryComponentVM;
    OnCancel: () => void;
    OnSave: () => void;
}

@observer
export default class ManageCheckQueryComponent extends React.Component<IManagedCheckQueryComponentProps> {
    public render() {
        var viewModel = this.props.viewModel;
        var editOrAdd = viewModel.managedCheckQuery.checkQueryId !== 0;
        return (
            <>{
                <Neo.Card title={editOrAdd ? TextConstants.Titles.EditCheckQueryConfiguration : TextConstants.Titles.AddCheckQueryConfiguration} className="m-1">
                    <Neo.Form
                        model={viewModel.managedCheckQuery}
                        validationDisplayMode={Validation.DisplayMode.AfterBlur}
                        onSubmit={() => this.props.OnSave()}
                        showSummaryModal>
                        <>
                            <Neo.GridLayout lg={2}>
                                <Neo.FormGroup 
                                    bind={viewModel.managedCheckQuery.meta.checkQueryCode}/>
                            </Neo.GridLayout>
                        </>
                        <Neo.FormGroup 
                            bind={viewModel.managedCheckQuery.meta.checkQueryDescription}
                            input={{ rows: 4}} />
                        <Neo.GridLayout lg={2}>
                            <Neo.FormGroup >
                                <Neo.AutoCompleteDropDown 
                                    itemSource={(searchCriteria) => viewModel.checkQueryApi.getStoredProcedureDropdownList(searchCriteria, "")}
                                    bind={viewModel.managedCheckQuery.meta.storedProcedureId}
                                    bindDisplay={viewModel.managedCheckQuery.meta.storedProcedureName}
                                    displayMember={"storedProcedure"}
                                    items={viewModel.checkQueryApi.getStoredProcedureDropdownList("", "").then((arr) => arr.data.slice(0, 10)
                                        .sort((x, y) => x.storedProcedure.localeCompare(y.storedProcedure)))}
                                />
                            </Neo.FormGroup>
                        </Neo.GridLayout>
                        <Neo.GridLayout lg={2}>
                            <Neo.FormGroup 
                                bind={(viewModel.managedCheckQuery.meta.tierId)}
                                select={{ items:viewModel.tierDropdownList, allowNulls: false}}
                            />
                        </Neo.GridLayout>
                        <div className="row customMarginTop29 float-right pr-3">
                                <Neo.Button 
                                    variant="primary" className="ml-3 col-md-2" isSubmit
                                >{TextConstants.Buttons.Save}</Neo.Button>
                                <Neo.Button className="ml-3 col-md-2"
                                    onClick={() => this.props.OnCancel()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Cancel}</Neo.Button>
                            </div>
                    </Neo.Form>
                </Neo.Card>
            }
        </>)
    }
}